import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuetify from 'vuetify'

import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
// ENTFERNT: import HttpService from './Http.js'
// WAR TOTER CODE: Der Dienst wurde nur eingebunden, aber nirgends verwendet —
// im gesamten src/ kam "HttpService" ausser in der Datei selbst nur in dieser
// Zeile vor. FOLGE: Beim Laden lief sein Konstruktor mit (restoreAuthorization
// liest "bearer-jwt" aus dem localStorage) und legte eine zweite, veraltete
// Anmeldeverwaltung neben $axios an. Die Datei src/Http.js kann geloescht werden.
import VueI18n from 'vue-i18n'
import messages from './assets/messages.json'
import VueNoty from 'vuejs-noty'
import 'vuetify/dist/vuetify.min.css'
import 'vue-cal/dist/vuecal.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vuejs-noty/dist/vuejs-noty.css'
import { getAxiosParams, getAWSImageUrls } from './constants.js'

// WYSIWYG Editor
import { VueEditor } from "vue2-editor";

// Vue Components
import Login from './components/Login.vue'
import Dashboard from './components/Dashboard.vue'
import Users from './components/Users.vue'
import Events from './components/Events.vue'
import PredefinedTrips from './components/PredefinedTrips.vue'
import Trips from './components/Trips.vue'
import Routes from './components/Routes.vue'
import Reported from './components/Reported.vue'
import Models from './components/Models.vue'
import Manufacturers from './components/Manufacturers.vue'
import Broadcast from './components/Broadcast.vue'
import UserAutos from './components/UserAutos.vue'
import BlacklistedUser from './components/BlacklistedUsers.vue'
import Posts from './components/Posts.vue'
import NewsMessages from './components/NewsMessages.vue'
import Crews from './components/Crews.vue'
import ValidateEmail from './components/ValidateEmail.vue'
import AppVersions from './components/AppVersions.vue'

// Widgets
import Upload from "./components/widget/Upload.vue"
import DatePicker from "./components/widget/DatePicker.vue"

import * as VueGoogleMaps from 'vue2-google-maps'

// Main Page
import App from './views/App.vue'

Vue.config.productionTip = false;

// Global Access Variables 
Vue.prototype.$axios = axios.create(getAxiosParams());
  
Vue.prototype.$axios.interceptors.request.use(
function (config) {
    const token = localStorage.getItem("id_token");
    if (token) {
    config.headers.Authorization = token;
    }
    return config;
},
function (error) {
    return Promise.reject(error);
}
);

/**
 * Abgelaufene oder ungültige Anmeldung führt zur Anmeldeseite.
 *
 * Ohne diese Behandlung blieb das Dashboard einfach leer stehen: Die Seiten
 * bauten sich auf, alle Abrufe scheiterten still im Hintergrund, und niemand
 * erfuhr, dass die Anmeldung nicht mehr gilt.
 */
// Mehrere Abrufe laufen oft gleichzeitig. Ohne diese Sperre bekäme der Nutzer
// bei fehlender Berechtigung für jeden einzelnen Abruf dieselbe Meldung.
let lastPermissionNoticeAt = 0;

Vue.prototype.$axios.interceptors.response.use(
function (response) {
    return response;
},
function (error) {
    const status = error && error.response ? error.response.status : null;

    if (status === 401) {
        localStorage.removeItem("id_token");
        // Auch die Nutzerdaten zurücksetzen, sonst bleibt das Seitenmenü
        // sichtbar, obwohl niemand mehr angemeldet ist
        Vue.prototype.$user = null;
        if (router.currentRoute.path !== "/login") {
            router.replace({
                path: "/login",
                query: { routingTarget: router.currentRoute.path },
            });
        }
    }

    // WAR FALSCH: Hier wurde nur 401 abgefangen. Der admin-Wächter des Backends
    // antwortet aber mit 403 (ETSBackend/middlewares/checkRole.js:11), wenn der
    // loginType nicht ADMIN ist. FOLGE: Wird jemand herabgestuft, scheitern alle
    // Abrufe still — die Oberfläche lässt sich weiter bedienen, bleibt aber leer,
    // ohne dass jemand den Grund erfährt.
    // Bewusst KEINE Abmeldung: 403 kommt auch bei einzelnen fremden Datensätzen
    // (ETSBackend/controllers/v1/routeController.js:418) und würde sonst jemanden
    // mitten in der Arbeit hinauswerfen.
    if (status === 403) {
        const now = Date.now();
        if (now - lastPermissionNoticeAt > 5000) {
            lastPermissionNoticeAt = now;
            const msg = "Dafür fehlt Ihnen die Berechtigung. Bitte melden Sie sich mit einem Verwaltungszugang an.";
            if (Vue.prototype.$noty) {
                Vue.prototype.$noty.error(msg);
            } else {
                console.warn(msg);
            }
        }
    }

    return Promise.reject(error);
}
);


Vue.prototype.$user = null;
Vue.prototype.$awsSmallImages = getAWSImageUrls().smallImages;
Vue.prototype.$awsMediumImages = getAWSImageUrls().mediumImages;
Vue.prototype.$awsLargeImages = getAWSImageUrls().largeImages;

// Bild-URL-Helfer (Ronny 2026-07-10): absolute URLs (http...) direkt nutzen,
// sonst die CloudFront-Basis voranstellen. Verhindert kaputte URLs wie
// ".../street/http://localhost:4000/uploads/seed/..." bei lokalen Seed-Bildern.
Vue.prototype.$img = function (val, base) {
  if (!val) return '/images/brand/favicon.png';
  val = String(val);
  if (val.startsWith('http')) return val;
  // Genau EIN Schrägstrich zwischen Basis und Name. Die Basisadressen in
  // constants.js enden bereits auf '/', ein zusätzliches '/' ergab
  // ".../street//abc.jpg" — die Ablage kennt aber nur "street/abc.jpg"
  // (ETSBackend/helpers/utils.js: Key: 'street/' + keyName). Lokal fiel das
  // nicht auf, weil die Testbilder vollständige Adressen tragen und oben
  // durchgereicht werden.
  return String(base).replace(/\/+$/, '') + '/' + val.replace(/^\/+/, '');
};

Vue.prototype.$mapsAPIKey = 'AIzaSyA49hyJ8uklbAuGVDMVZFrVbZrc3-DJTNQ';

// Hinweis: $formatDate steht weiter unten in dieser Datei. Hier stand eine
// zweite, unfertige Fassung ohne Rückgabewert — sie wurde von der späteren
// überschrieben und sah beim Lesen wie ein Fehler aus.

window.Vue = Vue;

// Use base Components
Vue.use(BootstrapVue)
Vue.use(Vuetify)
Vue.use(VueRouter)
Vue.use(VueEditor, /* { default global options} */)
Vue.component("vue-editor", VueEditor);

// Components
Vue.use(Login)

// Widgets
Vue.use(Upload)
Vue.component("Upload", Upload);
Vue.use(DatePicker)
Vue.component("DatePicker", DatePicker);
Vue.use(VueGoogleMaps, {
    load: {
      key: Vue.prototype.$mapsAPIKey,
      libraries: 'places',
    }
  });

// Language
Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: 'de',
    messages,
});


// Vuetify
const vuetifyOpts = {
    theme: {
        themes: {
            light: {
                primary: "#0069AE",
                secondary: "#003A61",
                accent: "#82B1FF",
                error: "#FF5252",
                info: "#2196F3",
                success: "#4CAF50",
                warning: "#FB8C00",
                grey: "#2f2f2f",
            }
        }
    }
};
const vuetify = new Vuetify(vuetifyOpts);


// Vue Router
const router = new VueRouter({
    routes: [
        {
            path: "/", component: Dashboard
        },
        { path: "/login", name: "Login", component: Login, props: route => ({ routingTarget: route.query.routingTarget }) },
        { path: "/dashboard", name: "Dashboard", component: Dashboard },
        { path: "/users", name: "Users", component: Users },
        { path: "/events", name: "Events", component: Events },
        { path: "/newsmessages", name: "NewsMessages", component: NewsMessages },
        { path: "/predefinedTrips", name: "PredefinedTrips", component: PredefinedTrips },
        { path: "/trips", name: "Trips", component: Trips },
        { path: "/routes", name: "Routes", component: Routes },
        { path: "/reported", name: "Reported", component: Reported },
        { path: "/crews", name: "Crews", component: Crews },
        // Belohnungen, Bestellungen und Level sind abgeschaltet (Ronny,
        // 05./06.08.2026) — die Menüpunkte in views/App.vue sind seitdem
        // auskommentiert. Die Routen blieben aber bestehen, sodass die Seiten
        // über zwei Knöpfe und über die direkte Adresse weiter erreichbar
        // waren. Genau dort lieferte die Bestellsuche komplette
        // Nutzerdatensätze samt Passwort-Hash an den Browser.
        //
        // ENTFERNT (Entscheidung Ronny, 15.08.2026): Die drei Seiten des
        // Prämien- und Level-Systems sind samt ihren Komponenten aus dem
        // Dashboard heraus. Das System ist vollständig ausgebaut — die
        // zugehörigen Serveradressen antworten mit 404, die Münzstände sind
        // zurückgesetzt. An seine Stelle tritt der Rang, den die App im
        // Profil zeigt und der aus Kilometern, Beiträgen, Kommentaren,
        // Treffen und Werbungen frisch gerechnet wird.
        { path: "/models", name: "Models", component: Models },
        { path: "/Manufacturers", name: "Manufacturers", component: Manufacturers },
        { path: "/broadcast", name: "Broadcast", component: Broadcast },
        { path: "/userAutos", name: "UserAutos", component: UserAutos },
        { path: "/blacklisted", name: "Blacklisted", component: BlacklistedUser },
        { path: "/posts", name: "Posts", component: Posts },
        { path: "/validateEmail/*/*/*", name: "ValidateEmail", component: ValidateEmail },
        { path: "/versions", name: "Versions", component: AppVersions },
        // Alles Unbekannte führt zur Startseite statt auf eine leere Fläche.
        // Ohne diesen Auffangeintrag zeigte eine unbekannte Adresse — etwa ein
        // altes Lesezeichen auf die abgeschalteten Belohnungsseiten — nur den
        // Seitenstreifen und daneben nichts.
        { path: "*", redirect: "/dashboard" }
    ],
    mode: "history"
});

/**
 * Ohne Anmeldung führt jeder Weg zur Anmeldeseite.
 *
 * Zuvor gab es keine Prüfung: Die Seiten bauten sich auf, auch ohne gültige
 * Anmeldung. Zu sehen bekam man zwar nichts — die Inhalte holt das Backend,
 * und das prüft jeden Aufruf —, aber es blieb unklar, warum alles leer ist.
 *
 * Das ursprünglich gewünschte Ziel wird als routingTarget mitgegeben, damit es
 * nach der Anmeldung direkt geöffnet werden kann.
 */
const OEFFENTLICHE_SEITEN = ["/login", "/validateEmail"];

router.beforeEach(function (to, from, next) {
    const istOeffentlich = OEFFENTLICHE_SEITEN.some(function (pfad) {
        return to.path === pfad || to.path.indexOf(pfad + "/") === 0;
    });
    const angemeldet = !!localStorage.getItem("id_token");

    if (istOeffentlich || angemeldet) {
        next();
        return;
    }
    next({ path: "/login", query: { routingTarget: to.path } });
});

Object.defineProperty(Vue.prototype, '$locale', {
    get: function () {
        return i18n.locale
    },
    set: function (locale) {
        i18n.locale = locale
    }
});


// Notifications
Vue.use(VueNoty, {
    timeout: 6000,
    progressBar: true,
    killer: true,
    layout: 'topRight'
});


// Global Methods
Vue.prototype.$formatDate = function(dateStr){
    return new Date(dateStr).toLocaleDateString(navigator.languages, { year: 'numeric', month: '2-digit', day: '2-digit' });
}

Vue.prototype.$formatUrlEncoded = function(json, appendFile = null){
    var formData = new FormData();
    for ( var key in json ) {
        let data = json[key];
        if(typeof data === 'object' || typeof data === 'array') data = JSON.stringify(data);
        formData.append(key, data);
    }

    // WAR FALSCH: Hier lief eine Schleife über `appendFile.length`. Alle Aufrufer
    // ausser NewsMessages.vue übergeben aber ein einzelnes File-Objekt, und
    // `File.length` ist `undefined` — die Schleife lief null Mal.
    // FOLGE: Das ausgewählte Bild landete nie im FormData und wurde beim Speichern
    // stillschweigend verworfen, ohne jede Fehlermeldung (Events, Trips,
    // PredefinedTrips, Levels, Rewards).
    // JETZT: Beide Aufrufarten funktionieren — einzelnes File wie auch Liste
    // (Array oder FileList) —, damit die Komponenten unverändert bleiben können.
    if(appendFile != null){
        const hasLength = typeof appendFile.length === 'number' && typeof appendFile !== 'string';
        const files = hasLength ? Array.from(appendFile) : [appendFile];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (file != null) formData.append('file', file);
        }
    }
    return formData;
}

Vue.prototype.$routerPush = function(path, right, elsePath = null){
    if(this.$rights.includes(right)){
        this.$router.push(path);
    }else if(elsePath != null){
        this.$router.push(elsePath);
    }
}

Vue.prototype.$routerBack = function(){
    this.$router.go(-1);
}

Vue.prototype.$showErrorMissing = function(field){
    const msg = "Das Feld " + field + " darf nicht leer sein.";
    this.$noty.error(msg);
}

Vue.prototype.$showErrorInvalid = function(field){
    const msg = "Das Feld " + field + " hat einen ungültigen Wert.";
    this.$noty.error(msg);
}

Vue.prototype.$showErrorFileSize = function(size){
    const msg = "Die Datei darf nicht größer als " + size + " MB sein.";
    this.$noty.error(msg);
}

Vue.prototype.$showCommonError = function(){
    const msg = "Etwas ist schief gelaufen";
    this.$noty.error(msg);
}

Vue.prototype.$showErrorWithMessage = function(error) {
    this.$noty.error(error.message);
}


new Vue({ 
    render: h => h(App),
    components: { App },
    i18n,
    router,
    vuetify,
    watch:{
        $route (to, from){
            window.scrollTo(0, 0);
        }
    },
    beforeCreate: function(){
        if(window.location.href.includes("?lang")){
            window.location.href = window.location.href.substring(0, window.location.href.indexOf("?"));
        }
        if(window.location.href.includes("%3Flang")){
            window.location.href = window.location.href.substring(0, window.location.href.indexOf("%3Flang"));
        }
    },
    beforeMount: function () {
        var _this = this;
        this.$axios.get("/user/profile/my/0/5").then(function(response){
            // FEHLER 4 (dasselbe Muster wie in Login.vue, onSuccessfulLogin):
            // Lehnt der Server den Profilabruf fachlich ab (HTTP 200,
            // success:false — z. B. weil das Konto zwischenzeitlich gesperrt
            // wurde, aber der gespeicherte Schlüssel noch technisch gültig
            // ist), setzte dieser Zweig trotzdem Vue.prototype.$user auf
            // response.data.data, also auf undefined. App.vue blendet Menü
            // und Kopfleiste über "$user != null" aus — "undefined != null"
            // ist in JavaScript falsch, beides verschwand also lautlos, ohne
            // dass zur Anmeldeseite weitergeleitet wurde. Jetzt gilt das wie
            // "nicht angemeldet".
            if (response.data == null || response.data.success === false) {
                console.warn("Profilabruf abgelehnt:", response.data && response.data.message);
                localStorage.removeItem("id_token");
                Vue.prototype.$user = null;
                _this.checkWindowLocationAndRouteToLogin();
                return;
            }
            const user = response.data.data;
            Vue.prototype.$user = user;
            // ENTFERNT: console.log("Current User", user);
            // WAR FALSCH: Das komplette Profil (Name, E-Mail, Kennung, Rolle) stand
            // bei jedem Seitenaufruf in der Konsole. FOLGE: Nutzerdaten landen in
            // Fehlerberichten und Bildschirmaufnahmen, ohne dass es jemand merkt.
        })
        .catch(function(error){
            // WAR FALSCH: console.log("Not logged in", error) gab das ganze
            // Fehlerobjekt aus — darin steckt error.config.headers.Authorization,
            // also das gültige Anmeldetoken. FOLGE: Ein Zugangsschlüssel in der
            // Konsole. Die Ursache steht in error.message und reicht völlig.
            console.warn("Nicht angemeldet:", error && error.message);
            _this.checkWindowLocationAndRouteToLogin();
            });
    },
    methods: {
        setUser(user) {
            this.user = user;
        },
        checkWindowLocationAndRouteToLogin(){
            var location = window.location.href;
            if(location.startsWith("http://") || location.startsWith("https://")) location = location.substring(location.indexOf("//") + 2);
            // ENTFERNT: console.log(location);
            // WAR HEIKEL: Die vollständige Adresse enthält bei
            // /validateEmail/<verschluesselteKennung>/<iv>/<code> einen einmaligen
            // Bestätigungscode (ETSBackend/controllers/v1/authController.js:459).
            // FOLGE: Der Code stand in der Konsole. Die Ausgabe unten reicht,
            // sie wird für /validateEmail gar nicht erst erreicht.
            const allowedRoutes = ["/login", "/validateEmail", "/app"];
            const unallowedRoutes = [];
            var routeAllowed = false;

            // Check allowedRoutes
            for (let i = 0; i < allowedRoutes.length; i++) {
                const allowedRoute = allowedRoutes[i];
                if(location.includes(allowedRoute)){
                    routeAllowed = true;
                    break;
                }
            }
            // Check unallowedRoutes
            for (let i = 0; i < unallowedRoutes.length; i++) {
                const unallowedRoute = unallowedRoutes[i];
                if(location.includes(unallowedRoute)){
                    routeAllowed = false;
                    break;
                }
            }
            if(routeAllowed) return;

            const unallowedRoute = location.substring(location.indexOf("/"));

            console.log(unallowedRoute);
            this.$router.push("/login?routingTarget=" + unallowedRoute);
        },
    }
}).$mount("#app");
